import React from 'react';
 
const AuthContext = React.createContext(null);
export default AuthContext;